import { render } from "./CreateProductModalComponent.vue?vue&type=template&id=671f2c6c&scoped=true"
import script from "./CreateProductModalComponent.vue?vue&type=script&lang=js"
export * from "./CreateProductModalComponent.vue?vue&type=script&lang=js"

import "./CreateProductModalComponent.vue?vue&type=style&index=0&id=671f2c6c&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671f2c6c"]])

export default __exports__